"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _airbnbPropTypes = require("airbnb-prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes2 = require("@agillic/prop-types");
var _avatar = _interopRequireDefault(require("../avatar/avatar.presenter"));
var _icon = _interopRequireDefault(require("../icon/icon.presenter"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Pill = function Pill(_ref) {
  var backgroundColor = _ref.backgroundColor,
    children = _ref.children,
    photoUrl = _ref.photoUrl,
    userInitials = _ref.userInitials,
    isDisabled = _ref.isDisabled,
    isSmall = _ref.isSmall,
    uniqueID = _ref.uniqueID;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('agillicPill', {
      disabled: isDisabled,
      small: isSmall
    })
  }, _react.default.createElement(_avatar.default, {
    shape: "circle",
    photoUrl: photoUrl,
    userName: children,
    size: isSmall ? 30 : 38,
    backgroundColor: backgroundColor,
    userInitials: userInitials,
    uniqueID: uniqueID
  }), _react.default.createElement("span", {
    className: "pillText"
  }, children), _react.default.createElement("button", {
    className: "removeButton"
  }, _react.default.createElement(_icon.default, {
    name: "times"
  })));
};
Pill.propTypes = {
  backgroundColor: (0, _airbnbPropTypes.and)([_propTypes.string, (0, _propTypes2.forbiddenBy)('photoUrl'), (0, _propTypes2.requiredBy)('userInitials')]),
  children: _propTypes.string.isRequired,
  photoUrl: _propTypes.string,
  userInitials: _propTypes.string,
  isDisabled: _propTypes.bool,
  isSmall: _propTypes.bool,
  uniqueID: _propTypes.string
};
Pill.defaultProps = {
  children: 'Text'
};
var _default = Pill;
exports.default = _default;